import { Component, AfterViewInit, ViewContainerRef, NgZone, ChangeDetectorRef, } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute, } from '@angular/router';

import {
  TdLoadingService,
  TdMediaService,
  TdDialogService,
  ITdDataTableColumn,
  TdDataTableSortingOrder,
  TdDataTableService,
  ITdDataTableSortChangeEvent,
} from '@covalent/core';

import { CitasService, LoginService } from '../../../services/';
import { Cita } from '../../../models/';
import { CitasDetalleComponent } from './citasdetalle/citasdetalle.component';

@Component({
  selector: 'qs-citas',
  templateUrl: './citas.component.html',
  styleUrls: ['./citas.component.scss'],
  viewProviders: [CitasService],
})

export class CitasComponent implements AfterViewInit {

  private idPaciente: string;
  private citas: any;

  // ITDdDataTableComponent
  // Columnas
  private columnsAll: ITdDataTableColumn[] = [
    { name: 'fecha', label: 'Fecha', tooltip: 'Fecha', sortable: true },
    { name: 'hora', label: 'Hora', tooltip: 'Hora', sortable: false },
    { name: 'centro', label: 'Centro', tooltip: 'Centro', sortable: false },
    { name: 'agenda', label: 'Agenda', tooltip: 'Agenda', sortable: false, hidden: true },
    { name: 'descripcion', label: 'Descripcion', tooltip: 'Descripción', sortable: false },
    { name: 'id', label: 'Id', tooltip: 'Id', sortable: false, hidden: true },
  ];

  private columns: ITdDataTableColumn[] = this.columnsAll;
  // Datos
  private filteredData: any[] = [];
  private filteredDataTotal: number;

  // Propiedades
  private clickable: boolean = true;
  private selectable: boolean = false;
  private sortable: boolean = true;
  private sortBy: string = 'fecha';
  private sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Descending;
  private searchTerm: string = '';

  constructor(private _titleService: Title,
    private _loadingService: TdLoadingService,
    private _dialogService: TdDialogService,
    public media: TdMediaService,
    private _citasService: CitasService,
    private _loginService: LoginService,
    private _dataTableService: TdDataTableService,
    private _ngZone: NgZone,
    private _router: Router,
    private _route: ActivatedRoute,
    private _changeDetectorRef: ChangeDetectorRef) { }

  ngAfterViewInit(): void {
    this.media.broadcast();
    this._titleService.setTitle('Citas');
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this.loadCitas();
    this._changeDetectorRef.detectChanges();
  }

  loadCitas(): void {
    this._loadingService.register('citas.load');
    this._citasService.obtenerCitas(this._loginService.consulta.cip).subscribe((res: any) => {
      if (res.error === '') {
        this.citas = [];
      } else {
        this.citas = res.respuesta.citas || [];
      }
      this.filteredData = this.citas;
      this.filteredDataTotal = this.citas.length;
      this._loadingService.resolve('citas.load');
    }, (error: Error) => {
      this._loginService.mostrarMensaje('Error obteniendo citas.', 'OK', 6000);
      this._loadingService.resolve('citas.load');
    });
  }

  openDetail(cita: any): void {
    let dialogRef: any = this._dialogService.open(CitasDetalleComponent, {
      data: cita,
      width: '75%',
      role: 'dialog',
    });
    dialogRef.componentInstance.nombreProfesional = this._loginService.profesional.Personal.Nombre
    + ' ' + this._loginService.profesional.Personal.Apellido1
    + ' ' + this._loginService.profesional.Personal.Apellido2;
    dialogRef.componentInstance.cita = cita;
    dialogRef.afterClosed().subscribe((result: any) => {
      this.loadCitas();
    });
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }

  search(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.citas;
    newData = this._dataTableService.filterData(newData, this.searchTerm, true);
    this.filteredDataTotal = newData.length;
    newData = this._dataTableService.sortData(newData, this.sortBy, this.sortOrder);
    this.filteredData = newData;
  }

}



// WEBPACK FOOTER //
// ./src/app/consulta/citas/citas.component.ts